// Translations for NexAir Elements - Immersive Brand Experiences
export const translations = {
  es: {
    // Navigation
    nav: {
      applications: "Aplicaciones",
      experiences: "Experiencias",
      process: "Proceso",
      skyMeetsWater: "Elements",
      faq: "FAQ",
      contact: "Contacto",
      designCampaign: "Solicitar Propuesta",
    },
    
    // Hero Section - REBRANDED
    hero: {
      title: "IMMERSIVE",
      titleHighlight: "BRAND EXPERIENCES",
      subtitle: "Shows de drones, pantallas de agua, FX y tecnología experiencial diseñados para crear momentos inolvidables para marcas y eventos en vivo.",
      cta: "Explorar Experiencias",
      ctaSimulate: "Solicitar Propuesta",
    },
    
    // Elements Section
    skyMeetsWater: {
      headline: "NexAir Elements",
      subheadline: "Experiencias inmersivas de marca",
      description: "Creamos experiencias multisensoriales que combinan tecnología de vanguardia con narrativa visual para transformar eventos en momentos inolvidables.",
      footer: "Disponible para activaciones de marca, eventos corporativos, turismo y experiencias de lujo",
    },
    
    // Problem Section - REBRANDED
    problem: {
      title: "La atención ya no se compra…",
      titleHighlight: "se conquista",
      description: "En un mundo saturado de estímulos, las experiencias memorables son la única forma de conectar emocionalmente con tu audiencia.",
      conclusion: "Si no generas algo extraordinario, simplemente eres olvidado.",
    },
    
    // Solution Section - REBRANDED
    solution: {
      title: "Transforma cualquier espacio en un",
      titleHighlight: "escenario inmersivo",
      description: "NexAir Elements crea experiencias que fusionan tecnología, arte y narrativa para generar",
      mediaImpact: "impacto emocional",
      viralContent: "contenido viral",
      brandRecall: "conexión de marca",
    },
    
    // Impact Section - REBRANDED
    impact: {
      title: "Más que un show,",
      titleHighlight: "una experiencia",
      items: [
        "Conexión emocional con tu audiencia",
        "Contenido viral generado por asistentes",
        "Cobertura mediática global",
        "Experiencias memorables e inmersivas",
        "Posicionamiento premium de marca",
      ],
    },
    
    // Applications Section - REBRANDED
    applications: {
      title: "Experiencias para",
      titleHighlight: "Cada Ocasión",
      items: {
        brands: {
          title: "Activaciones de Marca",
          description: "Experiencias diseñadas para engagement, impacto viral y conexión emocional con tu audiencia.",
        },
        realEstate: {
          title: "Lanzamientos Premium",
          description: "Inauguraciones y lanzamientos que posicionan productos y proyectos como únicos.",
        },
        tourism: {
          title: "Turismo y Destinos",
          description: "Atracciones y espectáculos que transforman destinos en experiencias inolvidables.",
        },
        government: {
          title: "Eventos Culturales",
          description: "Celebraciones cívicas, festivales y eventos gubernamentales de alto impacto.",
        },
        private: {
          title: "Experiencias de Lujo",
          description: "Bodas, celebraciones exclusivas y eventos privados de clase mundial.",
        },
      },
    },
    
    // Process Section - REBRANDED
    process: {
      title: "Nuestro",
      titleHighlight: "Proceso",
      steps: [
        { number: "01", title: "Briefing Creativo", description: "Entendemos tu visión, objetivos y audiencia para diseñar la experiencia perfecta." },
        { number: "02", title: "Diseño de Experiencia", description: "Nuestro equipo crea el concepto visual, tecnológico y narrativo de tu evento." },
        { number: "03", title: "Producción", description: "Desarrollamos todo el contenido, coreografías y elementos técnicos." },
        { number: "04", title: "Ejecución", description: "Desplegamos nuestro equipo y tecnología para una ejecución impecable." },
      ],
    },
    
    // Services Section - REBRANDED
    services: {
      title: "Nuestros",
      titleHighlight: "Servicios",
      droneShows: {
        title: "Shows de Drones",
        description: "Coreografías aéreas sincronizadas con cientos de drones para crear narrativas visuales de alto impacto en el cielo nocturno.",
      },
      waterScreens: {
        title: "Pantallas de Agua",
        description: "Proyecciones inmersivas sobre superficies de agua para experiencias cinematográficas de marca.",
      },
      specialFX: {
        title: "Efectos Especiales",
        description: "Láser, iluminación, pirotecnia y tecnologías visuales inmersivas para crear atmósferas únicas.",
      },
      brandActivations: {
        title: "Activaciones de Marca",
        description: "Conceptos experienciales diseñados para engagement de audiencia e impacto viral.",
      },
    },
    
    // Drone Show Section - REBRANDED
    droneShow: {
      sectionTitle: "Shows de",
      sectionTitleHighlight: "Drones",
      description: "Coreografías aéreas con cientos de drones sincronizados que crean figuras, logos y narrativas visuales espectaculares en el cielo nocturno.",
    },
    
    // Water Screen Section - REBRANDED
    waterScreen: {
      sectionTitle: "Pantallas de",
      sectionTitleHighlight: "Agua",
      description: "Proyecciones de alta definición sobre cortinas de agua que transforman cualquier espacio en un escenario cinematográfico e inmersivo.",
    },
    
    // CTA Section - REBRANDED
    cta: {
      title: "¿Listo para crear una",
      titleHighlight: "experiencia inolvidable",
      subtitle: "Contáctanos para diseñar tu próxima activación inmersiva.",
      button: "Solicitar Propuesta",
      whatsappMessage: "Hola, me interesa crear una experiencia inmersiva con NexAir Elements",
    },
    
    // FAQ Section - REBRANDED
    faq: {
      title: "Preguntas",
      titleHighlight: "Frecuentes",
      items: [
        { question: "¿Qué servicios ofrece NexAir Elements?", answer: "Ofrecemos shows de drones, pantallas de agua, efectos especiales (láser, iluminación, pirotecnia), activaciones de marca y tecnología experiencial para crear experiencias inmersivas." },
        { question: "¿Cuánto tiempo toma producir una experiencia?", answer: "Dependiendo de la complejidad, nuestras producciones toman entre 4 a 12 semanas desde el briefing inicial hasta la ejecución." },
        { question: "¿Trabajan internacionalmente?", answer: "Sí, NexAir Elements opera en México, Latinoamérica y el Caribe. Contáctanos para proyectos en otras regiones." },
        { question: "¿Se requieren permisos especiales?", answer: "Sí, NexAir Elements gestiona todos los permisos aeronáuticos, de seguridad y gubernamentales necesarios para cada evento." },
        { question: "¿Qué tipo de eventos son ideales para sus servicios?", answer: "Lanzamientos de producto, activaciones de marca, festivales, eventos corporativos, turismo, bodas de lujo, eventos gubernamentales y celebraciones culturales." },
      ],
    },
    
    // Contact Section - REBRANDED
    contact: {
      title: "Solicitar",
      titleHighlight: "Propuesta",
      subtitle: "Comparte los detalles de tu evento y nuestro equipo creará una propuesta personalizada.",
      info: {
        title: "Contáctanos para crear tu experiencia inmersiva perfecta.",
        address: "México, Latinoamérica y el Caribe"
      },
      form: {
        name: "Nombre completo",
        email: "Email corporativo",
        phone: "Teléfono (opcional)",
        company: "Empresa / Organización",
        eventType: "Tipo de evento",
        eventDate: "Fecha estimada",
        location: "Ubicación del evento",
        attendees: "Número de asistentes",
        serviceType: "Servicio de interés",
        message: "Cuéntanos sobre tu visión (opcional)",
        submit: "Enviar Solicitud",
        submitting: "Enviando...",
        sending: "Enviando..."
      },
      eventTypes: [
        "Activación de Marca",
        "Lanzamiento de Producto",
        "Evento Corporativo",
        "Festival / Concierto",
        "Evento de Turismo",
        "Boda / Celebración Privada",
        "Evento Gubernamental / Cultural",
        "Otro",
      ],
      success: "¡Solicitud enviada! Nuestro equipo te contactará en las próximas 24-48 horas.",
      error: "Hubo un error al enviar tu solicitud. Por favor intenta de nuevo.",
    },
    
    // Simulation Section - REBRANDED
    simulation: {
      title: "Visualiza tu",
      titleHighlight: "Experiencia",
      subtitle: "Nuestro equipo puede crear una visualización personalizada de cómo se vería tu experiencia inmersiva.",
      form: {
        projectName: "Nombre del proyecto",
        projectType: "Tipo de experiencia",
        location: "Ubicación",
        date: "Fecha estimada",
        budget: "Presupuesto aproximado",
        whatsapp: "WhatsApp de contacto",
        email: "Email",
        uploadLogo: "Subir logo o referencia (opcional)",
        disclaimer: "Al enviar esta solicitud, aceptas que NexAir Elements te contacte para discutir tu proyecto.",
        submit: "Solicitar Visualización",
        submitting: "Enviando...",
      },
      projectTypes: [
        "Show de Drones",
        "Pantalla de Agua",
        "Experiencia Combinada",
        "Efectos Especiales",
        "Activación de Marca",
      ],
      termsTitle: "Términos de Uso",
      termsContent: [
        "Al utilizar el servicio de visualización de NexAir Elements, usted acepta los siguientes términos:",
        "1. Las visualizaciones son representaciones artísticas y pueden variar del resultado final.",
        "2. El contenido generado es propiedad de NexAir Elements hasta que se formalice un contrato.",
        "3. NexAir Elements se reserva el derecho de utilizar las visualizaciones con fines promocionales.",
        "4. Los tiempos de entrega son estimados y pueden variar según la complejidad del proyecto.",
      ],
      success: "¡Solicitud recibida! Nuestro equipo creativo te contactará pronto.",
      error: "Hubo un error al enviar tu solicitud. Por favor intenta de nuevo.",
    },
    
    // Visualize Section (alias for VisualizaCampanaSection)
    visualize: {
      subtitle: "Sube tu logo o imagen y te mostramos cómo se vería tu proyecto en el cielo",
      formTitle: "Solicita tu Visualización",
      formSubtitle: "Completa el formulario y nuestro equipo creará tu simulación personalizada",
      form: {
        projectName: "Nombre del proyecto",
        projectNamePlaceholder: "Ej: Lanzamiento Torre Stellar",
        uploadLabel: "Logo o imagen de referencia",
        uploadButton: "Click para subir archivo",
        uploadHint: "PNG, JPG o SVG (máx. 5MB)",
        description: "Descripción del proyecto",
        descriptionPlaceholder: "Describe tu evento o proyecto...",
        projectType: "Tipo de proyecto",
        selectType: "Selecciona tipo",
        city: "Ciudad",
        cityPlaceholder: "Selecciona ciudad",
        date: "Fecha estimada",
        budget: "Presupuesto",
        selectBudget: "Selecciona rango",
        whatsapp: "WhatsApp",
        whatsappPlaceholder: "+52 55 1234 5678",
        email: "Email",
        emailPlaceholder: "tu@email.com",
        submit: "Solicitar Visualización Gratis",
        sending: "Enviando..."
      },
      projectTypes: [
        "Show de Drones",
        "Pantalla de Agua",
        "Experiencia Combinada (Drones + Water)",
        "Efectos Especiales",
        "Activación de Marca"
      ],
      cities: [
        "Ciudad de México",
        "Monterrey",
        "Guadalajara",
        "Cancún",
        "Los Cabos",
        "Otra ciudad"
      ],
      budgetRanges: [
        "$50,000 - $100,000 MXN",
        "$100,000 - $300,000 MXN",
        "$300,000 - $500,000 MXN",
        "$500,000 - $1,000,000 MXN",
        "+$1,000,000 MXN"
      ],
      examples: {
        title: "Ejemplos de Visualizaciones",
        subtitle: "Mira cómo hemos transformado proyectos de nuestros clientes",
        cards: [
          { title: "Lanzamiento Automotriz", description: "Show de drones con logo de marca" },
          { title: "Festival de Música", description: "Coreografía sincronizada" },
          { title: "Desarrollo Inmobiliario", description: "Proyección del proyecto" },
          { title: "Evento Corporativo", description: "Mensaje personalizado" },
          { title: "Boda Premium", description: "Figuras románticas" },
          { title: "Celebración Pública", description: "Símbolos patrios" }
        ],
        footer: "Cada visualización es única y personalizada para tu proyecto",
        footerSub: "Tiempo de entrega: 48-72 horas hábiles"
      },
      success: {
        title: "¡Solicitud Enviada!",
        subtitle: "Nuestro equipo creará tu visualización y te contactará pronto.",
        whatsappButton: "Continuar por WhatsApp",
        whatsappMessage: "Hola, acabo de enviar mi solicitud de visualización para el proyecto: {projectName}"
      },
      toastSuccess: "¡Solicitud enviada! Te contactaremos pronto.",
      toastError: "Error al enviar. Por favor intenta de nuevo.",
      disclaimer: "Las visualizaciones son representaciones artísticas y pueden variar del resultado final. Al enviar este formulario, aceptas que NexAir Elements te contacte para discutir tu proyecto.",
      termsLink: "Ver términos y condiciones"
    },
    
    // Terms modal
    terms: {
      title: "Términos y Condiciones",
      content: [
        "Al utilizar el servicio de visualización de NexAir Elements, usted acepta los siguientes términos:",
        "1. Las visualizaciones son representaciones artísticas y pueden variar del resultado final.",
        "2. El contenido generado es propiedad de NexAir Elements hasta que se formalice un contrato.",
        "3. NexAir Elements se reserva el derecho de utilizar las visualizaciones con fines promocionales.",
        "4. Los tiempos de entrega son estimados y pueden variar según la complejidad del proyecto."
      ],
      close: "Cerrar"
    },
    
    // Footer - REBRANDED
    footer: {
      rights: "Todos los derechos reservados.",
      legalNotice: "Aviso Legal:",
      legalText: "Las visualizaciones mostradas son representaciones artísticas. Los resultados reales pueden variar según las condiciones del evento. NexAir Elements opera bajo todas las regulaciones aplicables.",
    },
    
    // Common SEO Page Components
    seoCommon: {
      backToHome: "Volver al inicio",
      contactWhatsApp: "Contactar por WhatsApp",
      requestQuote: "Solicitar Propuesta",
    },
    
    // SEO Pages
    seoPages: {
      // Drone Show Page
      droneShow: {
        title: "Shows de Drones",
        subtitle: "El cielo como tu escenario",
        description: "Coreografías aéreas con cientos de drones sincronizados que crean figuras, logos y narrativas visuales espectaculares.",
        whyChoose: "¿Por qué elegir",
        whyChooseHighlight: "Shows de Drones",
        benefits: {
          visualImpact: { title: "Impacto Visual Único", desc: "Cientos de drones sincronizados creando figuras y logos en el cielo nocturno" },
          massReach: { title: "Alcance Masivo", desc: "Captura la atención de miles de espectadores y genera contenido viral" },
          ecoFriendly: { title: "Eco-Friendly", desc: "Alternativa sustentable a los fuegos artificiales tradicionales" },
          customization: { title: "Personalización Total", desc: "Diseños a medida con tu logo, mensaje o figuras personalizadas" },
        },
        howItWorks: "¿Cómo funciona un Show de Drones?",
        howItWorksDesc1: "Nuestros shows utilizan tecnología de última generación para sincronizar perfectamente cientos de aeronaves equipadas con luces LED de alta intensidad. Cada dron es controlado por software avanzado que permite crear figuras, logos, textos y animaciones con precisión milimétrica.",
        howItWorksDesc2: "El proceso incluye diseño personalizado, pruebas de vuelo, coordinación con autoridades aeronáuticas y ejecución profesional. Nuestro equipo se encarga de todos los permisos y logística necesaria.",
        useCases: [
          "Lanzamientos de productos y marcas",
          "Eventos corporativos y conciertos",
          "Festivales y celebraciones públicas",
          "Bodas y eventos privados exclusivos",
          "Inauguraciones y aperturas",
          "Campañas publicitarias de alto impacto",
        ],
        galleryTitle: "Galería de Shows",
        galleryDesc: "Explora algunos de nuestros shows más espectaculares realizados para marcas líderes y eventos de alto perfil.",
        stats: {
          drones: "Drones disponibles",
          shows: "Shows realizados",
          spectators: "Espectadores impactados",
          satisfaction: "Satisfacción",
        },
        ctaTitle: "¿Listo para tu Show de Drones?",
        ctaSubtitle: "Contáctanos y diseñemos juntos la experiencia perfecta para tu evento",
        ctaWhatsapp: "Hola, me interesa cotizar un show de drones con NexAir Elements",
      },
      
      // Water Screen Page
      waterScreen: {
        title: "Pantallas de Agua",
        subtitle: "Donde la magia cobra vida",
        description: "Proyecciones cinematográficas sobre cortinas de agua que transforman cualquier espacio en un escenario inmersivo.",
        immersiveTitle: "Experiencias",
        immersiveHighlight: "Inmersivas",
        immersiveSuffix: "con Agua",
        benefits: {
          hdScreen: { title: "Proyección HD", desc: "Proyecciones de alta definición sobre cortinas de agua de hasta 20 metros de altura" },
          magicEffects: { title: "Efectos Cinematográficos", desc: "Combina agua, luz y sonido para crear experiencias inmersivas únicas" },
          customContent: { title: "Contenido Personalizado", desc: "Videos, animaciones, logos y mensajes proyectados sobre agua" },
          syncAudio: { title: "Audio Sincronizado", desc: "Sistema de sonido profesional perfectamente sincronizado con las proyecciones" },
        },
        whatIs: "¿Qué es una Pantalla de Agua?",
        whatIsDesc1: "Una pantalla de agua es una tecnología innovadora que crea una cortina de agua atomizada sobre la cual se proyectan imágenes, videos y efectos visuales de alta definición. El resultado es una experiencia visual impactante que parece flotar en el aire.",
        whatIsDesc2: "Perfecta para eventos nocturnos, lanzamientos de productos, espectáculos públicos y activaciones de marca que buscan sorprender y cautivar a su audiencia.",
        features: [
          "Proyecciones sobre cortinas de agua de 10 a 20 metros",
          "Resolución HD para imágenes nítidas",
          "Contenido 100% personalizable",
          "Ideal para interiores y exteriores",
          "Instalación temporal o permanente",
          "Efectos de fuego, láser y pirotecnia opcional",
        ],
        galleryTitle: "Galería Water Screen",
        galleryDesc: "Descubre el poder de las proyecciones sobre agua en nuestros eventos más destacados.",
        applicationsTitle: "Aplicaciones Ideales",
        applications: {
          corporate: { title: "Eventos Corporativos", desc: "Lanzamientos de productos, convenciones y galas empresariales" },
          entertainment: { title: "Entretenimiento", desc: "Conciertos, festivales y espectáculos públicos" },
          tourism: { title: "Turismo", desc: "Atracciones permanentes en hoteles, parques y centros comerciales" },
          weddings: { title: "Bodas", desc: "Momentos mágicos e inolvidables para celebraciones especiales" },
          advertising: { title: "Publicidad", desc: "Campañas de alto impacto con proyecciones de marca" },
          architecture: { title: "Arquitectura", desc: "Instalaciones artísticas y fachadas interactivas" },
        },
        ctaTitle: "Crea Magia con Agua",
        ctaSubtitle: "Transforma tu próximo evento con una experiencia visual única",
        ctaWhatsapp: "Hola, me interesa cotizar una pantalla de agua con NexAir Elements",
      },
      
      // Elements Page
      skyMeetsWater: {
        title: "NexAir Elements",
        subtitle: "Experiencias inmersivas multisensoriales",
        description: "La experiencia más completa: shows de drones, pantallas de agua, efectos especiales y tecnología experiencial en perfecta sincronía.",
        newDimension: "Una Nueva Dimensión en",
        newDimensionHighlight: "Experiencias Inmersivas",
        introDesc1: "NexAir Elements es nuestra experiencia premium que combina lo mejor de múltiples tecnologías: el espectáculo aéreo de cientos de drones sincronizados, la magia de las proyecciones sobre pantallas de agua, efectos de láser, iluminación y pirotecnia. El resultado es un show multisensorial que transforma cualquier evento en un momento histórico.",
        introDesc2: "Imagina drones formando tu logo en el cielo mientras proyecciones cinematográficas aparecen sobre cortinas de agua. Láser, fuego y música sincronizados creando una experiencia que tu audiencia nunca olvidará. Las posibilidades son infinitas.",
        whyChoose: "¿Por qué elegir NexAir Elements?",
        benefits: {
          multidimensional: { title: "Experiencia Multidimensional", desc: "Combina espectáculo aéreo, proyecciones acuáticas y efectos especiales para un impacto sin precedentes" },
          wowEffect: { title: "Efecto WOW Garantizado", desc: "La sincronización perfecta entre todos los elementos crea momentos que dejan sin aliento a la audiencia" },
          narrative: { title: "Narrativa Visual Completa", desc: "Cuenta historias que fluyen entre cielo, agua y tierra en una coreografía perfecta" },
          exclusivity: { title: "Exclusividad Total", desc: "Somos pioneros en experiencias inmersivas integradas en Latinoamérica" },
        },
        processTitle: "Nuestro Proceso",
        processSteps: [
          { step: "01", title: "Briefing Creativo", desc: "Entendemos tu visión, objetivos y requisitos del evento" },
          { step: "02", title: "Diseño de Experiencia", desc: "Nuestro equipo diseña la coreografía combinada personalizada" },
          { step: "03", title: "Producción", desc: "Programación, creación de contenido visual y pruebas técnicas" },
          { step: "04", title: "Ejecución", desc: "Montaje profesional y show en vivo con equipo técnico completo" },
        ],
        galleryTitle: "Galería de Experiencias",
        galleryDesc: "Explora los momentos más impactantes de nuestras producciones inmersivas.",
        idealFor: "Ideal para Eventos Premium",
        idealForDesc: "NexAir Elements está diseñado para eventos que buscan marcar la diferencia y crear recuerdos imborrables. Es la opción perfecta cuando quieres superar todas las expectativas.",
        idealForList: [
          "Lanzamientos de productos de alto perfil",
          "Activaciones de marca premium",
          "Festivales y celebraciones de fin de año",
          "Eventos corporativos exclusivos",
          "Atracciones turísticas permanentes",
          "Bodas de lujo y celebraciones VIP",
        ],
        ctaTitle: "Crea la Experiencia Definitiva",
        ctaSubtitle: "Combina tecnología y emoción para un evento que nadie olvidará",
        ctaWhatsapp: "Hola, me interesa cotizar una experiencia inmersiva con NexAir Elements",
      },
      
      // Drones for Events Page
      dronesForEvents: {
        title: "Drones para Eventos",
        subtitle: "El complemento perfecto para cualquier celebración",
        description: "Desde bodas íntimas hasta festivales masivos, nuestros shows de drones se adaptan a cualquier tipo de evento para crear momentos inolvidables.",
        eventTypesTitle: "Tipos de",
        eventTypesHighlight: "Eventos",
        eventTypesSuffix: "que Transformamos",
        eventTypes: {
          corporate: { 
            title: "Eventos Corporativos", 
            desc: "Convenciones, lanzamientos, aniversarios empresariales y galas de premiación",
            features: ["Logo de empresa en el cielo", "Mensajes personalizados", "Sincronización con presentaciones"]
          },
          weddings: { 
            title: "Bodas y Celebraciones", 
            desc: "Momentos mágicos para bodas, XV años, aniversarios y fiestas privadas",
            features: ["Corazones y figuras románticas", "Nombres de los festejados", "Coordinación con DJ y música"]
          },
          concerts: { 
            title: "Conciertos y Festivales", 
            desc: "Shows sincronizados con música en vivo para miles de espectadores",
            features: ["Coreografías musicales", "Efectos dinámicos", "Interacción con el escenario"]
          },
          public: { 
            title: "Eventos Públicos", 
            desc: "Celebraciones cívicas, fiestas patrias, fin de año y ferias",
            features: ["Figuras representativas", "Mensajes institucionales", "Alto alcance de audiencia"]
          },
        },
        whyDronesTitle: "¿Por qué Drones para tu Evento?",
        whyDrones: [
          { title: "Impacto Visual", desc: "Miles de luces sincronizadas creando figuras imposibles en el cielo" },
          { title: "Contenido Viral", desc: "Los asistentes capturan y comparten, multiplicando el alcance de tu evento" },
          { title: "Eco-Friendly", desc: "Sin humo, sin ruido excesivo, sin residuos - 100% sustentable" },
          { title: "Seguro", desc: "Tecnología certificada y operadores profesionales con todos los permisos" },
          { title: "Versátil", desc: "Funciona en espacios abiertos de cualquier tamaño" },
          { title: "Memorable", desc: "Crea recuerdos únicos que los asistentes nunca olvidarán" },
        ],
        galleryTitle: "Eventos Realizados",
        galleryDesc: "Cada evento es único. Mira cómo hemos transformado celebraciones de todo tipo con nuestros shows.",
        pricingTitle: "Opciones para Cada Proyecto",
        pricingTiers: {
          essential: { name: "Esencial", ideal: "Bodas y eventos privados", features: ["Figuras básicas", "1 diseño personalizado", "Música sincronizada"] },
          premium: { name: "Premium", ideal: "Eventos corporativos", features: ["Figuras complejas", "Logo + mensaje", "Múltiples secuencias", "Coordinación con evento"] },
          spectacular: { name: "Espectacular", ideal: "Festivales y eventos masivos", features: ["Show completo", "Animaciones avanzadas", "Múltiples diseños", "Producción integral"] },
        },
        pricingNote: "Todos los precios incluyen: diseño, programación, operación, permisos y seguro",
        mostPopular: "MÁS POPULAR",
        drones: "drones",
        showDuration: "de show",
        idealFor: "Ideal para:",
        ctaTitle: "¿Tienes un evento próximo?",
        ctaSubtitle: "Cuéntanos sobre tu evento y diseñamos la experiencia perfecta",
        ctaWhatsapp: "Hola, tengo un evento y me interesa cotizar un show de drones con NexAir Elements",
      },
      
      // Brand Activations Page
      brandActivations: {
        title: "Activaciones de Marca",
        subtitle: "Tu marca en una experiencia inmersiva",
        description: "Posiciona tu marca de manera única con experiencias inmersivas que generan impacto visual, contenido viral y conexión emocional con tu audiencia.",
        marketingTitle: "Marketing que",
        marketingHighlight: "Trasciende",
        benefits: {
          highImpact: { title: "Alto Impacto", desc: "Tu marca brillando en experiencias que capturan la atención de todos" },
          virality: { title: "Viralidad Garantizada", desc: "El contenido generado se comparte masivamente en redes sociales" },
          premiumContent: { title: "Contenido Premium", desc: "Material audiovisual espectacular para tus campañas" },
          amplification: { title: "Amplificación", desc: "Los asistentes se convierten en embajadores de tu marca" },
        },
        whatIncludesTitle: "¿Qué Incluye una Activación?",
        whatIncludesDesc: "Una activación de marca con NexAir Elements es mucho más que un espectáculo. Es una estrategia de marketing integral que genera awareness, engagement y contenido de alto valor para tu marca.",
        whatIncludesList: [
          "Diseño personalizado de experiencia inmersiva",
          "Estrategia de contenido para redes sociales",
          "Cobertura profesional de foto y video",
          "Coordinación con tu equipo de marketing",
          "Material listo para tus campañas digitales",
          "Medición de impacto y alcance",
        ],
        activationTypesTitle: "Tipos de Activaciones",
        activationTypes: {
          productLaunch: { title: "Lanzamientos de Producto", desc: "Presenta tu nuevo producto con una experiencia que nadie olvidará.", ideal: "Automotriz, tecnología, retail, bebidas" },
          openings: { title: "Inauguraciones", desc: "Abre las puertas de tu nuevo espacio con un espectáculo que marque el inicio de una nueva era.", ideal: "Hoteles, centros comerciales, desarrollos inmobiliarios" },
          brandEvents: { title: "Eventos de Marca", desc: "Transforma tu evento de marca en una experiencia inolvidable que conecte emocionalmente con tu audiencia.", ideal: "Fashion, lifestyle, deportes, entretenimiento" },
          adCampaigns: { title: "Campañas Publicitarias", desc: "Crea el contenido más impactante para tu próxima campaña con experiencias únicas e irrepetibles.", ideal: "Agencias de publicidad, marcas globales" },
        },
        idealForLabel: "Ideal para:",
        galleryTitle: "Marcas que Han Brillado",
        galleryDesc: "Descubre cómo grandes marcas han elevado su presencia con nuestras activaciones.",
        roiTitle: "El ROI de una Activación Inmersiva",
        roiStats: {
          reach: { value: "10x", desc: "Mayor alcance orgánico vs publicidad tradicional" },
          sharing: { value: "85%", desc: "De los asistentes comparte contenido del show" },
          impressions: { value: "+5M", desc: "Impresiones potenciales por evento" },
        },
        roiDesc: "Una activación con NexAir Elements no es un gasto, es una inversión en awareness, engagement y contenido premium que sigue generando valor mucho después del evento.",
        ctaTitle: "Lleva tu Marca al Siguiente Nivel",
        ctaSubtitle: "Agenda una llamada y diseñemos tu próxima activación",
        ctaWhatsapp: "Hola, me interesa cotizar una activación de marca con NexAir Elements",
      },
    },
  },
  
  en: {
    // Navigation
    nav: {
      applications: "Applications",
      experiences: "Experiences",
      process: "Process",
      skyMeetsWater: "Elements",
      faq: "FAQ",
      contact: "Contact",
      designCampaign: "Request Proposal",
    },
    
    // Hero Section - REBRANDED
    hero: {
      title: "IMMERSIVE",
      titleHighlight: "BRAND EXPERIENCES",
      subtitle: "Drone shows, water screens, FX and experiential technology designed to create unforgettable moments for brands and live events.",
      cta: "Explore Experiences",
      ctaSimulate: "Request Proposal",
    },
    
    // Elements Section
    skyMeetsWater: {
      headline: "NexAir Elements",
      subheadline: "Immersive brand experiences",
      description: "We create multisensory experiences that combine cutting-edge technology with visual narrative to transform events into unforgettable moments.",
      footer: "Available for brand activations, corporate events, tourism and luxury experiences",
    },
    
    // Problem Section - REBRANDED
    problem: {
      title: "Attention is no longer bought…",
      titleHighlight: "it's earned",
      description: "In a world saturated with stimuli, memorable experiences are the only way to emotionally connect with your audience.",
      conclusion: "If you don't create something extraordinary, you're simply forgotten.",
    },
    
    // Solution Section - REBRANDED
    solution: {
      title: "Transform any space into an",
      titleHighlight: "immersive stage",
      description: "NexAir Elements creates experiences that fuse technology, art and narrative to generate",
      mediaImpact: "emotional impact",
      viralContent: "viral content",
      brandRecall: "brand connection",
    },
    
    // Impact Section - REBRANDED
    impact: {
      title: "More than a show,",
      titleHighlight: "an experience",
      items: [
        "Emotional connection with your audience",
        "Viral content generated by attendees",
        "Global media coverage",
        "Memorable and immersive experiences",
        "Premium brand positioning",
      ],
    },
    
    // Applications Section - REBRANDED
    applications: {
      title: "Experiences for",
      titleHighlight: "Every Occasion",
      items: {
        brands: {
          title: "Brand Activations",
          description: "Experiences designed for engagement, viral impact and emotional connection with your audience.",
        },
        realEstate: {
          title: "Premium Launches",
          description: "Inaugurations and launches that position products and projects as unique.",
        },
        tourism: {
          title: "Tourism & Destinations",
          description: "Attractions and shows that transform destinations into unforgettable experiences.",
        },
        government: {
          title: "Cultural Events",
          description: "Civic celebrations, festivals and high-impact government events.",
        },
        private: {
          title: "Luxury Experiences",
          description: "Weddings, exclusive celebrations and world-class private events.",
        },
      },
    },
    
    // Process Section - REBRANDED
    process: {
      title: "Our",
      titleHighlight: "Process",
      steps: [
        { number: "01", title: "Creative Briefing", description: "We understand your vision, objectives and audience to design the perfect experience." },
        { number: "02", title: "Experience Design", description: "Our team creates the visual, technological and narrative concept for your event." },
        { number: "03", title: "Production", description: "We develop all content, choreographies and technical elements." },
        { number: "04", title: "Execution", description: "We deploy our team and technology for flawless execution." },
      ],
    },
    
    // Services Section - REBRANDED
    services: {
      title: "Our",
      titleHighlight: "Services",
      droneShows: {
        title: "Drone Shows",
        description: "Synchronized aerial choreography with hundreds of drones to create high-impact visual narratives in the night sky.",
      },
      waterScreens: {
        title: "Water Screens",
        description: "Immersive projections on water surfaces for cinematic brand experiences.",
      },
      specialFX: {
        title: "Special Effects",
        description: "Laser, lighting, pyrotechnics and immersive visual technologies to create unique atmospheres.",
      },
      brandActivations: {
        title: "Brand Activations",
        description: "Experiential concepts designed for audience engagement and viral impact.",
      },
    },
    
    // Drone Show Section - REBRANDED
    droneShow: {
      sectionTitle: "Drone",
      sectionTitleHighlight: "Shows",
      description: "Aerial choreography with hundreds of synchronized drones creating spectacular figures, logos and visual narratives in the night sky.",
    },
    
    // Water Screen Section - REBRANDED
    waterScreen: {
      sectionTitle: "Water",
      sectionTitleHighlight: "Screens",
      description: "High-definition projections on water curtains that transform any space into a cinematic and immersive stage.",
    },
    
    // CTA Section - REBRANDED
    cta: {
      title: "Ready to create an",
      titleHighlight: "unforgettable experience",
      subtitle: "Contact us to design your next immersive activation.",
      button: "Request Proposal",
      whatsappMessage: "Hello, I'm interested in creating an immersive experience with NexAir Elements",
    },
    
    // FAQ Section - REBRANDED
    faq: {
      title: "Frequently",
      titleHighlight: "Asked Questions",
      items: [
        { question: "What services does NexAir Elements offer?", answer: "We offer drone shows, water screens, special effects (laser, lighting, pyrotechnics), brand activations and experiential technology to create immersive experiences." },
        { question: "How long does it take to produce an experience?", answer: "Depending on complexity, our productions take between 4 to 12 weeks from initial briefing to execution." },
        { question: "Do you work internationally?", answer: "Yes, NexAir Elements operates in Mexico, Latin America and the Caribbean. Contact us for projects in other regions." },
        { question: "Are special permits required?", answer: "Yes, NexAir Elements manages all aeronautical, safety and government permits required for each event." },
        { question: "What types of events are ideal for your services?", answer: "Product launches, brand activations, festivals, corporate events, tourism, luxury weddings, government events and cultural celebrations." },
      ],
    },
    
    // Contact Section - REBRANDED
    contact: {
      title: "Request",
      titleHighlight: "Proposal",
      subtitle: "Share your event details and our team will create a personalized proposal.",
      info: {
        title: "Contact us to create your perfect immersive experience.",
        address: "Mexico, Latin America and the Caribbean"
      },
      form: {
        name: "Full name",
        email: "Corporate email",
        phone: "Phone (optional)",
        company: "Company / Organization",
        eventType: "Event type",
        eventDate: "Estimated date",
        location: "Event location",
        attendees: "Number of attendees",
        serviceType: "Service of interest",
        message: "Tell us about your vision (optional)",
        submit: "Send Request",
        submitting: "Sending...",
        sending: "Sending..."
      },
      eventTypes: [
        "Brand Activation",
        "Product Launch",
        "Corporate Event",
        "Festival / Concert",
        "Tourism Event",
        "Wedding / Private Celebration",
        "Government / Cultural Event",
        "Other",
      ],
      success: "Request sent! Our team will contact you within 24-48 hours.",
      error: "There was an error sending your request. Please try again.",
    },
    
    // Simulation Section - REBRANDED
    simulation: {
      title: "Visualize your",
      titleHighlight: "Experience",
      subtitle: "Our team can create a personalized visualization of what your immersive experience would look like.",
      form: {
        projectName: "Project name",
        projectType: "Experience type",
        location: "Location",
        date: "Estimated date",
        budget: "Approximate budget",
        whatsapp: "WhatsApp contact",
        email: "Email",
        uploadLogo: "Upload logo or reference (optional)",
        disclaimer: "By submitting this request, you agree that NexAir Elements may contact you to discuss your project.",
        submit: "Request Visualization",
        submitting: "Sending...",
      },
      projectTypes: [
        "Drone Show",
        "Water Screen",
        "Combined Experience",
        "Special Effects",
        "Brand Activation",
      ],
      termsTitle: "Terms of Use",
      termsContent: [
        "By using the NexAir Elements visualization service, you agree to the following terms:",
        "1. Visualizations are artistic representations and may vary from the final result.",
        "2. Generated content is property of NexAir Elements until a contract is formalized.",
        "3. NexAir Elements reserves the right to use visualizations for promotional purposes.",
        "4. Delivery times are estimated and may vary depending on project complexity.",
      ],
      success: "Request received! Our creative team will contact you soon.",
      error: "There was an error sending your request. Please try again.",
    },
    
    // Visualize Section (alias for VisualizaCampanaSection)
    visualize: {
      subtitle: "Upload your logo or image and we'll show you how your project would look in the sky",
      formTitle: "Request Your Visualization",
      formSubtitle: "Fill out the form and our team will create your personalized simulation",
      form: {
        projectName: "Project name",
        projectNamePlaceholder: "Ex: Stellar Tower Launch",
        uploadLabel: "Logo or reference image",
        uploadButton: "Click to upload file",
        uploadHint: "PNG, JPG or SVG (max 5MB)",
        description: "Project description",
        descriptionPlaceholder: "Describe your event or project...",
        projectType: "Project type",
        selectType: "Select type",
        city: "City",
        cityPlaceholder: "Select city",
        date: "Estimated date",
        budget: "Budget",
        selectBudget: "Select range",
        whatsapp: "WhatsApp",
        whatsappPlaceholder: "+1 555 123 4567",
        email: "Email",
        emailPlaceholder: "your@email.com",
        submit: "Request Free Visualization",
        sending: "Sending..."
      },
      projectTypes: [
        "Drone Show",
        "Water Screen",
        "Combined Experience (Drones + Water)",
        "Special Effects",
        "Brand Activation"
      ],
      cities: [
        "Mexico City",
        "Monterrey",
        "Guadalajara",
        "Cancun",
        "Los Cabos",
        "Other city"
      ],
      budgetRanges: [
        "$5,000 - $10,000 USD",
        "$10,000 - $30,000 USD",
        "$30,000 - $50,000 USD",
        "$50,000 - $100,000 USD",
        "+$100,000 USD"
      ],
      examples: {
        title: "Visualization Examples",
        subtitle: "See how we've transformed our clients' projects",
        cards: [
          { title: "Automotive Launch", description: "Drone show with brand logo" },
          { title: "Music Festival", description: "Synchronized choreography" },
          { title: "Real Estate Development", description: "Project projection" },
          { title: "Corporate Event", description: "Custom message" },
          { title: "Premium Wedding", description: "Romantic figures" },
          { title: "Public Celebration", description: "National symbols" }
        ],
        footer: "Each visualization is unique and personalized for your project",
        footerSub: "Delivery time: 48-72 business hours"
      },
      success: {
        title: "Request Sent!",
        subtitle: "Our team will create your visualization and contact you soon.",
        whatsappButton: "Continue on WhatsApp",
        whatsappMessage: "Hello, I just submitted my visualization request for the project: {projectName}"
      },
      toastSuccess: "Request sent! We'll contact you soon.",
      toastError: "Error sending. Please try again.",
      disclaimer: "Visualizations are artistic representations and may vary from the final result. By submitting this form, you agree that NexAir Elements may contact you to discuss your project.",
      termsLink: "View terms and conditions"
    },
    
    // Terms modal
    terms: {
      title: "Terms and Conditions",
      content: [
        "By using the NexAir Elements visualization service, you agree to the following terms:",
        "1. Visualizations are artistic representations and may vary from the final result.",
        "2. Generated content is property of NexAir Elements until a contract is formalized.",
        "3. NexAir Elements reserves the right to use visualizations for promotional purposes.",
        "4. Delivery times are estimated and may vary depending on project complexity."
      ],
      close: "Close"
    },
    
    // Footer - REBRANDED
    footer: {
      rights: "All rights reserved.",
      legalNotice: "Legal Notice:",
      legalText: "The visualizations shown are artistic representations. Actual results may vary depending on event conditions. NexAir Elements operates under all applicable regulations.",
    },
    
    // Common SEO Page Components
    seoCommon: {
      backToHome: "Back to home",
      contactWhatsApp: "Contact via WhatsApp",
      requestQuote: "Request Proposal",
    },
    
    // SEO Pages
    seoPages: {
      // Drone Show Page
      droneShow: {
        title: "Drone Shows",
        subtitle: "The sky as your stage",
        description: "Aerial choreography with hundreds of synchronized drones creating spectacular figures, logos and visual narratives.",
        whyChoose: "Why choose",
        whyChooseHighlight: "Drone Shows",
        benefits: {
          visualImpact: { title: "Unique Visual Impact", desc: "Hundreds of synchronized drones creating figures and logos in the night sky" },
          massReach: { title: "Massive Reach", desc: "Capture the attention of thousands of spectators and generate viral content" },
          ecoFriendly: { title: "Eco-Friendly", desc: "Sustainable alternative to traditional fireworks" },
          customization: { title: "Total Customization", desc: "Custom designs with your logo, message or personalized figures" },
        },
        howItWorks: "How does a Drone Show work?",
        howItWorksDesc1: "Our shows use cutting-edge technology to perfectly synchronize hundreds of aircraft equipped with high-intensity LED lights. Each drone is controlled by advanced software that allows creating figures, logos, texts and animations with millimetric precision.",
        howItWorksDesc2: "The process includes custom design, flight tests, coordination with aeronautical authorities and professional execution. Our team handles all permits and necessary logistics.",
        useCases: [
          "Product and brand launches",
          "Corporate events and concerts",
          "Festivals and public celebrations",
          "Exclusive weddings and private events",
          "Grand openings and inaugurations",
          "High-impact advertising campaigns",
        ],
        galleryTitle: "Show Gallery",
        galleryDesc: "Explore some of our most spectacular shows created for leading brands and high-profile events.",
        stats: {
          drones: "Available drones",
          shows: "Shows performed",
          spectators: "Spectators impacted",
          satisfaction: "Satisfaction",
        },
        ctaTitle: "Ready for your Drone Show?",
        ctaSubtitle: "Contact us and let's design the perfect experience for your event",
        ctaWhatsapp: "Hello, I'm interested in getting a quote for a drone show with NexAir Elements",
      },
      
      // Water Screen Page
      waterScreen: {
        title: "Water Screens",
        subtitle: "Where magic comes to life",
        description: "Cinematic projections on water curtains that transform any space into an immersive stage.",
        immersiveTitle: "Immersive",
        immersiveHighlight: "Experiences",
        immersiveSuffix: "with Water",
        benefits: {
          hdScreen: { title: "HD Projection", desc: "High-definition projections on water curtains up to 20 meters high" },
          magicEffects: { title: "Cinematic Effects", desc: "Combines water, light and sound to create unique immersive experiences" },
          customContent: { title: "Custom Content", desc: "Videos, animations, logos and messages projected on water" },
          syncAudio: { title: "Synchronized Audio", desc: "Professional sound system perfectly synchronized with projections" },
        },
        whatIs: "What is a Water Screen?",
        whatIsDesc1: "A water screen is an innovative technology that creates an atomized water curtain on which high-definition images, videos and visual effects are projected. The result is a stunning visual experience that seems to float in the air.",
        whatIsDesc2: "Perfect for nighttime events, product launches, public shows and brand activations looking to surprise and captivate their audience.",
        features: [
          "Projections on 10 to 20 meter water curtains",
          "HD resolution for crisp images",
          "100% customizable content",
          "Ideal for indoor and outdoor",
          "Temporary or permanent installation",
          "Optional fire, laser and pyrotechnic effects",
        ],
        galleryTitle: "Water Screen Gallery",
        galleryDesc: "Discover the power of water projections in our most outstanding events.",
        applicationsTitle: "Ideal Applications",
        applications: {
          corporate: { title: "Corporate Events", desc: "Product launches, conventions and business galas" },
          entertainment: { title: "Entertainment", desc: "Concerts, festivals and public shows" },
          tourism: { title: "Tourism", desc: "Permanent attractions in hotels, parks and shopping centers" },
          weddings: { title: "Weddings", desc: "Magical and unforgettable moments for special celebrations" },
          advertising: { title: "Advertising", desc: "High-impact campaigns with brand projections" },
          architecture: { title: "Architecture", desc: "Artistic installations and interactive facades" },
        },
        ctaTitle: "Create Magic with Water",
        ctaSubtitle: "Transform your next event with a unique visual experience",
        ctaWhatsapp: "Hello, I'm interested in getting a quote for a water screen with NexAir Elements",
      },
      
      // Elements Page
      skyMeetsWater: {
        title: "NexAir Elements",
        subtitle: "Multisensory immersive experiences",
        description: "The most complete experience: drone shows, water screens, special effects and experiential technology in perfect synchrony.",
        newDimension: "A New Dimension in",
        newDimensionHighlight: "Immersive Experiences",
        introDesc1: "NexAir Elements is our premium experience that combines the best of multiple technologies: the aerial spectacle of hundreds of synchronized drones, the magic of projections on water screens, laser effects, lighting and pyrotechnics. The result is a multisensory show that transforms any event into a historic moment.",
        introDesc2: "Imagine drones forming your logo in the sky while cinematic projections appear on water curtains. Laser, fire and music synchronized creating an experience your audience will never forget. The possibilities are endless.",
        whyChoose: "Why choose NexAir Elements?",
        benefits: {
          multidimensional: { title: "Multidimensional Experience", desc: "Combines aerial spectacle, water projections and special effects for unprecedented impact" },
          wowEffect: { title: "Guaranteed WOW Effect", desc: "Perfect synchronization between all elements creates breathtaking moments" },
          narrative: { title: "Complete Visual Narrative", desc: "Tell stories that flow between sky, water and earth in perfect choreography" },
          exclusivity: { title: "Total Exclusivity", desc: "We are pioneers in integrated immersive experiences in Latin America" },
        },
        processTitle: "Our Process",
        processSteps: [
          { step: "01", title: "Creative Briefing", desc: "We understand your vision, objectives and event requirements" },
          { step: "02", title: "Experience Design", desc: "Our team designs the customized combined choreography" },
          { step: "03", title: "Production", desc: "Programming, visual content creation and technical testing" },
          { step: "04", title: "Execution", desc: "Professional setup and live show with complete technical team" },
        ],
        galleryTitle: "Experience Gallery",
        galleryDesc: "Explore the most impactful moments from our immersive productions.",
        idealFor: "Ideal for Premium Events",
        idealForDesc: "NexAir Elements is designed for events that seek to make a difference and create indelible memories. It's the perfect choice when you want to exceed all expectations.",
        idealForList: [
          "High-profile product launches",
          "Premium brand activations",
          "Year-end festivals and celebrations",
          "Exclusive corporate events",
          "Permanent tourist attractions",
          "Luxury weddings and VIP celebrations",
        ],
        ctaTitle: "Create the Ultimate Experience",
        ctaSubtitle: "Combine technology and emotion for an event no one will forget",
        ctaWhatsapp: "Hello, I'm interested in getting a quote for an immersive experience with NexAir Elements",
      },
      
      // Drones for Events Page
      dronesForEvents: {
        title: "Drones for Events",
        subtitle: "The perfect complement for any celebration",
        description: "From intimate weddings to massive festivals, our drone shows adapt to any type of event to create unforgettable moments.",
        eventTypesTitle: "Types of",
        eventTypesHighlight: "Events",
        eventTypesSuffix: "We Transform",
        eventTypes: {
          corporate: { 
            title: "Corporate Events", 
            desc: "Conventions, launches, business anniversaries and award galas",
            features: ["Company logo in the sky", "Personalized messages", "Synchronization with presentations"]
          },
          weddings: { 
            title: "Weddings and Celebrations", 
            desc: "Magical moments for weddings, quinceañeras, anniversaries and private parties",
            features: ["Hearts and romantic figures", "Names of the celebrants", "Coordination with DJ and music"]
          },
          concerts: { 
            title: "Concerts and Festivals", 
            desc: "Shows synchronized with live music for thousands of spectators",
            features: ["Musical choreographies", "Dynamic effects", "Stage interaction"]
          },
          public: { 
            title: "Public Events", 
            desc: "Civic celebrations, national holidays, New Year's Eve and fairs",
            features: ["Representative figures", "Institutional messages", "High audience reach"]
          },
        },
        whyDronesTitle: "Why Drones for your Event?",
        whyDrones: [
          { title: "Visual Impact", desc: "Thousands of synchronized lights creating impossible figures in the sky" },
          { title: "Viral Content", desc: "Attendees capture and share, multiplying your event's reach" },
          { title: "Eco-Friendly", desc: "No smoke, no excessive noise, no waste - 100% sustainable" },
          { title: "Safe", desc: "Certified technology and professional operators with all permits" },
          { title: "Versatile", desc: "Works in open spaces of any size" },
          { title: "Memorable", desc: "Create unique memories that attendees will never forget" },
        ],
        galleryTitle: "Events Completed",
        galleryDesc: "Each event is unique. See how we've transformed celebrations of all types with our shows.",
        pricingTitle: "Options for Every Project",
        pricingTiers: {
          essential: { name: "Essential", ideal: "Weddings and private events", features: ["Basic figures", "1 custom design", "Synchronized music"] },
          premium: { name: "Premium", ideal: "Corporate events", features: ["Complex figures", "Logo + message", "Multiple sequences", "Event coordination"] },
          spectacular: { name: "Spectacular", ideal: "Festivals and massive events", features: ["Complete show", "Advanced animations", "Multiple designs", "Full production"] },
        },
        pricingNote: "All prices include: design, programming, operation, permits and insurance",
        mostPopular: "MOST POPULAR",
        drones: "drones",
        showDuration: "show",
        idealFor: "Ideal for:",
        ctaTitle: "Have an upcoming event?",
        ctaSubtitle: "Tell us about your event and we'll design the perfect experience",
        ctaWhatsapp: "Hello, I have an event and I'm interested in getting a quote for a drone show with NexAir Elements",
      },
      
      // Brand Activations Page
      brandActivations: {
        title: "Brand Activations",
        subtitle: "Your brand in an immersive experience",
        description: "Position your brand uniquely with immersive experiences that generate visual impact, viral content and emotional connection with your audience.",
        marketingTitle: "Marketing that",
        marketingHighlight: "Transcends",
        benefits: {
          highImpact: { title: "High Impact", desc: "Your brand shining in experiences that capture everyone's attention" },
          virality: { title: "Guaranteed Virality", desc: "Generated content is massively shared on social media" },
          premiumContent: { title: "Premium Content", desc: "Spectacular audiovisual material for your campaigns" },
          amplification: { title: "Amplification", desc: "Attendees become ambassadors for your brand" },
        },
        whatIncludesTitle: "What Does an Activation Include?",
        whatIncludesDesc: "A brand activation with NexAir Elements is much more than a show. It's a comprehensive marketing strategy that generates awareness, engagement and high-value content for your brand.",
        whatIncludesList: [
          "Custom immersive experience design",
          "Social media content strategy",
          "Professional photo and video coverage",
          "Coordination with your marketing team",
          "Ready-to-use material for your digital campaigns",
          "Impact and reach measurement",
        ],
        activationTypesTitle: "Types of Activations",
        activationTypes: {
          productLaunch: { title: "Product Launches", desc: "Present your new product with an experience no one will forget.", ideal: "Automotive, technology, retail, beverages" },
          openings: { title: "Grand Openings", desc: "Open the doors of your new space with a spectacle that marks the beginning of a new era.", ideal: "Hotels, shopping centers, real estate developments" },
          brandEvents: { title: "Brand Events", desc: "Transform your brand event into an unforgettable experience that emotionally connects with your audience.", ideal: "Fashion, lifestyle, sports, entertainment" },
          adCampaigns: { title: "Advertising Campaigns", desc: "Create the most impactful content for your next campaign with unique and unrepeatable experiences.", ideal: "Advertising agencies, global brands" },
        },
        idealForLabel: "Ideal for:",
        galleryTitle: "Brands That Have Shined",
        galleryDesc: "Discover how major brands have elevated their presence with our activations.",
        roiTitle: "The ROI of an Immersive Activation",
        roiStats: {
          reach: { value: "10x", desc: "Greater organic reach vs traditional advertising" },
          sharing: { value: "85%", desc: "Of attendees share content from the show" },
          impressions: { value: "+5M", desc: "Potential impressions per event" },
        },
        roiDesc: "An activation with NexAir Elements is not an expense, it's an investment in awareness, engagement and premium content that continues generating value long after the event.",
        ctaTitle: "Take Your Brand to the Next Level",
        ctaSubtitle: "Schedule a call and let's design your next activation",
        ctaWhatsapp: "Hello, I'm interested in getting a quote for a brand activation with NexAir Elements",
      },
    },
  },
};

export default translations;
